const mixin = {
    computed: {
        computedSize() {
            return this.size ? this.size : 16;
        },
    }
}
export default mixin;
